import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface NotificationSliceState {
  dubsToPoll: {
    projectId: string;
    sourceFileIds: string[];
    projectName?: string;
  }[];
}

const initialState = {
  dubsToPoll: []
};

export const notificationSlice = createSlice({
  name: "notificationHandler",
  initialState: initialState as NotificationSliceState,
  reducers: {
    addDubsToPoll: (
      state,
      action: PayloadAction<{
        projectId: string;
        sourceFileIds: string[];
        projectName?: string;
        index?: number;
      }>
    ) => {
      if (action.payload.index !== undefined) {
        const temp = state.dubsToPoll.filter(
          (i) => i.projectId !== action.payload.projectId
        );
        state.dubsToPoll = [
          ...temp.slice(0, action.payload.index),
          {
            projectId: action.payload.projectId,
            sourceFileIds: action.payload.sourceFileIds,
            projectName: action.payload.projectName
          },
          ...temp.slice(action.payload.index)
        ];
      } else {
        const index = state.dubsToPoll.findIndex(
          (dub) => dub.projectId === action.payload.projectId
        );
        const _payload = {
          projectId: action.payload.projectId,
          sourceFileIds: action.payload.sourceFileIds,
          projectName: action.payload.projectName
        };
        if (index === -1) {
          state.dubsToPoll.push(_payload);
        } else {
          state.dubsToPoll[index] = _payload;
        }
      }
    },
    removeDubsToPoll: (
      state,
      action: PayloadAction<{ projectId: string; sourceFileIds?: string[] }>
    ) => {
      if (action.payload.sourceFileIds?.length) {
        state.dubsToPoll = state.dubsToPoll.map((dub) =>
          dub.projectId !== action.payload.projectId
            ? dub
            : {
                ...dub,
                sourceFileIds: [...(action.payload.sourceFileIds || [])]
              }
        );
      } else {
        state.dubsToPoll = state.dubsToPoll.filter(
          (dub) => dub.projectId !== action.payload.projectId
        );
      }
    },
    clearDubsToPoll: (state) => {
      state.dubsToPoll = [];
    }
  }
});
export default notificationSlice.reducer;
